const model = {
  id: 0,
  title: '',
  mailingStreet: '',
  mailingCity: '',
  county: '',
  mailingState: '',
  mailingStateAbbreviation: '',
  mailingPostalCode: '',
  defaultProgram: '',
  defaultLocation: '',
  organizationTypes: []
}

export { model }



// WEBPACK FOOTER //
// ./src/api/models/organization.js